import { TextareaAutosize } from '@mui/base';
import { Send } from '@mui/icons-material';
import { Avatar, IconButton } from '@mui/joy';
import { CircularProgress } from '@mui/material';
import axios from 'axios';
import { toLower, upperFirst } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { Button, Col, Container, Form, FormControl, FormSelect, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { pictos } from '../assets/img/pictos';
import ChatReceive from '../components/ChatReceive';
import ChatSend from '../components/ChatSend';
import Chemin from '../components/Chemin';
import ErrorPopup from '../components/ErrorPopup';
import Navigation from '../components/Navigation';
import { ListItemSkeleton } from '../components/skeletons';
import { NotifNbreContext } from '../Context';
import { PoliceDefaut } from '../helpers/contants';
import { isMessageEditable } from '../helpers/messageEdit';
import { useDelayedLoading } from '../hooks/useDelayedLoading';
import { SOCKETURL, URL } from '../redux/api';
import { NotificationsRedux, creerRdv, listMessage, refreshToken } from '../redux/profilService';
import { standChat } from '../redux/profilSlice';
import { UpdateNotification } from '../redux/updatesServices';
import '../styles/chat.css';
import textConnect from '../textConnect.json';
import { capture } from '../services/analytics';
import { affichageDate, displayContactNameFromFull, formatTimeTo24h } from './fonctions';

const Chatbox = () => {
  const monProfil = useSelector(state => state.profil.profil);
  const AccessToken = useSelector(state => state.user.access);
  const refresh_token = useSelector(state => state.user.refresh);

  const user_id = useSelector(state => state.profil.profil.id);
  const chat_id = useSelector(state => state.profil.idConversation);

  const listeNotifications = useSelector(state => state.profil.notifications);

  const notifChat = listeNotifications.filter(item => item.id_target === chat_id);

  const [eventId, setEventId] = useState('');
  const [heureDebut, setHeureDebut] = useState('');
  const [heureFin, setHeureFin] = useState('');
  const [sujetRdv, setSujetRdv] = useState('');
  const [lesRendezvous, setLesRendezvous] = useState('');
  const [descriptionRdv, setDescriptionRdv] = useState('');
  const [standRdv, setStandRdv] = useState('');
  const [idDestRdv, setIdDestRdv] = useState('');

  const choixEvent = async e => {
    const eventIdValue = e.target.value;
    setEventId(eventIdValue);
    setStandRdv('');
    if (!eventIdValue) {
      dispatch(standChat([]));
      return;
    }
    try {
      const response = await axios.get(`${URL}/api/stand/${eventIdValue}`, {
        headers: {
          Authorization: 'JWT ' + AccessToken,
        },
      });
      dispatch(standChat(response.data || []));
    } catch {
      dispatch(standChat([]));
    }
  };

  const [circular, setCircular] = useState(false);
  const [loading, setLoading] = useState(true);
  const showLoading = useDelayedLoading(loading, 500);

  function standLieu(e) {
    setStandRdv(e.target.value);
  }

  const user_chat = useSelector(state => state.profil.chat);
  const [message, setMessage] = useState('');
  const param = useParams();
  const [messageFilDisc, setMessageFilDisc] = useState([]);
  const [editingMessageId, setEditingMessageId] = useState(null);
  const [contact, setContact] = useState();
  const { readyState, sendJsonMessage } = useWebSocket(
    `${SOCKETURL}/chat/${param.room}/?token=${AccessToken}`,
    {
      onOpen: () => {
        console.log('Connected!');
      },
      onClose: () => {
        console.log('Disconnected!');
      },
      onMessage: e => {
        const data = JSON.parse(e.data);
        let chat = document.getElementById('container-chat');
        switch (data.type) {
          case 'chat_message':
            setMessageFilDisc(prev => prev.concat(data));

            setTimeout(() => {
              if (chat.scrollHeight === null) {
                chat.scrollTop = 0;
              } else {
                chat.scrollTop = chat.scrollHeight;
              }
            }, 200);
            setLoading(false);
            break;
          case 'delete_message':
            setMessageFilDisc(prev => {
              const newFil = prev.filter(
                msg => String(msg.id) !== String(data.pkid) && String(msg.id) !== String(data.uuid)
              );
              return newFil;
            });
            break;
          case 'edit_message':
            setMessageFilDisc(prev =>
              prev.map(msg =>
                String(msg.id) === String(data.pkid) || String(msg.id) === String(data.uuid)
                  ? { ...msg, message: data.message, editedAt: data.editedAt }
                  : msg
              )
            );
            setEditingMessageId(null);
            break;
          case 'edit_rejected':
            setEditingMessageId(null);
            setMsgError(data.message || "Ce message n'a pas pu être modifié.");
            setOpenError(true);
            break;
          case 'limit_reached':
            setMsgError(
              data.message ||
                'Vous pouvez contacter au maximum 20 personnes par semaine. Cette limite se réinitialise tous les lundis.'
            );
            setOpenError(true);
            break;
          default:
            break;
        }
      },
    }
  );
  const navigationPage = useNavigate();
  const [netStatus, setNetStatus] = useState(() => {
    if (navigator.onLine) {
      console.log('Connected to network.');
      return true;
    } else {
      return false;
    }
  });

  useEffect(() => {
    window.ononline = e => {
      console.log('Connected to network.');
      setNetStatus(true);
    };
    window.onoffline = e => {
      console.log('Network connection lost.');
      setNetStatus(false);
    };
  }, [netStatus]);
  //Suppression du fil de discussion
  const deleteFilDisc = async id => {
    await axios
      .post(
        `${URL}/api/delete-conversation`,
        {
          conversation: id,
        },
        {
          headers: {
            Authorization: 'JWT ' + AccessToken,
          },
        }
      )
      .then(navigationPage('/messagerie'))
      .catch(
        // console.log('erreur de suppression fil de discussion')
        setMsgError('erreur de suppression fil de discussion'),
        setOpenError(true)
      );
  };

  const [openError, setOpenError] = useState(false);
  const [msgError, setMsgError] = useState('');

  const closeErrorHandle = () => {
    setOpenError(false);
  };

  const nbreNotif = useContext(NotifNbreContext);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: 'Profil/addChemin',
      payload: breadcrumbs_temp,
    });

    listMessage(AccessToken, param.chatid)
      .then(async data => {
        setMessageFilDisc([...data.messages]);
        setLesRendezvous(data.rendezvous);
        setLoading(false);
        setTimeout(() => {
          let chat = document.getElementById('container-chat');
          if (chat.scrollHeight === null) {
            chat.scrollTop = 0;
          } else {
            chat.scrollTop = chat.scrollHeight;
          }
        }, 300);

        let contacts = data.conversation;
        if (contacts.participant_1.id === user_id) {
          setContact(displayContactNameFromFull(contacts.participant_2.nom));
          setIdDestRdv(contacts.participant_2.id);
        } else {
          setContact(displayContactNameFromFull(contacts.participant_1.nom));
          setIdDestRdv(contacts.participant_1.id);
        }
      })
      .catch(erreur => {
        setLoading(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');

              setLoading(false);
              // handleContacts()
            });
          }
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // console.log(listeNotifications[0].id_target)
    if (notifChat.length !== 0) {
      notifChat.map(item =>
        UpdateNotification(item.id, AccessToken).then(response => {
          NotificationsRedux(AccessToken).then(reponse => {
            dispatch({
              type: 'Profil/addNotifications',
              payload: reponse.data.filter(
                item => item.participant_recepteur.id === monProfil.id && item.etat === false
              ),
            });
            nbreNotif.setNbre(
              reponse.data.filter(
                item => item.participant_recepteur.id === monProfil.id && item.etat === false
              ).length
            );
          });
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifChat]);

  const handleClick = e => {
    sendJsonMessage({
      type: 'chat_message',
      message: document.getElementById('messageText').value.trim(),
    });
    capture('message_sent_web');
    setMessage('');
    document.getElementById('messageText').value = '';
  };

  const submitEdit = (messageId, texte) => {
    sendJsonMessage({
      type: 'edit',
      id: messageId,
      message: texte,
    });
  };

  const msgText = e => {
    document.getElementById('messageText').value.trim() !== ''
      ? setMessage('message')
      : setMessage('');

    window.scrollTo({
      left: 0,
      top: document.body.scrollHeight,
      behavior: 'instant',
    });
  };

  const [openSupprimer, setOpenSupprimer] = useState(false);
  const [openRdv, setOpenRdv] = useState(false);

  // const [selectChat, setSelectChat] = useState()
  const fermerRdv = () => {
    setOpenRdv(false);
    setEventId('');
    setHeureDebut('');
    setHeureFin('');
    setSujetRdv('');
    setDescriptionRdv('');
    //setLieuRdv('');
    setStandRdv('');
    setIdDestRdv('');
    dispatch(standChat([]));
  };
  const ouvrirSupprimer = id => {
    // setSelectChat(id)
    setOpenSupprimer(true);
    // console.log(id)
  };
  const evenementsChat = useSelector(state => state.profil.chatEvenement);
  const standsChat = useSelector(state => state.profil.chatStand);

  // const acceptRdvHandle = (rdv_id) => {
  //   const notifRdv = listeNotifications.filter(item => item.id_target === rdv_id)
  //   try {
  //     accepterRdv(lesRendezvous.programme.id, lesRendezvous.destinateur, AccessToken, param.chatid, setOpenAcceptRdv, setLesRendezvous)
  //     if (notifRdv.length !== 0) {
  //       UpdateNotification(notifRdv[0].id, AccessToken).then((response) => {
  //         NotificationsRedux(AccessToken)
  //           .then((reponse) => {
  //             dispatch(
  //               {
  //                 type: 'Profil/addNotifications',
  //                 payload: reponse.data.filter(item =>
  //                   item.participant_recepteur.id === monProfil.id && item.etat === false
  //                 )
  //               }
  //             );
  //             nbreNotif.setNbre(reponse.data.filter(item =>
  //               item.participant_recepteur.id === monProfil.id && item.etat === false
  //             ).length)
  //           })
  //       })
  //     }

  //   } catch (error) {
  //     console.log('erreur acceptation rendez-vous')
  //   }

  // }
  // const refuseRdvHandle = (rdv_id) => {
  //   const notifRdv = listeNotifications.filter(item => item.id_target === rdv_id)
  //   try {
  //     refuserrRdv(lesRendezvous.programme.id, lesRendezvous.destinateur, AccessToken, param.chatid, setOpenAcceptRdv, setLesRendezvous)
  //     if (notifRdv.length !== 0) {
  //       UpdateNotification(notifRdv[0].id, AccessToken).then((response) => {
  //         NotificationsRedux(AccessToken)
  //           .then((reponse) => {
  //             dispatch(
  //               {
  //                 type: 'Profil/addNotifications',
  //                 payload: reponse.data.filter(item =>
  //                   item.participant_recepteur.id === monProfil.id && item.etat === false
  //                 )
  //               }
  //             );
  //             nbreNotif.setNbre(reponse.data.filter(item =>
  //               item.participant_recepteur.id === monProfil.id && item.etat === false
  //             ).length)
  //           })
  //       })
  //     }

  //   } catch (error) {
  //     console.log('erreur acceptation rendez-vous')
  //   }

  // }
  const location = useLocation();
  //Breadcrumbs - build from Accueil/{origin} to avoid inheriting duplicate contact from previous page
  const breadCrumbs = useSelector(state => state.profil.chemin);
  const breadcrumbs_temp = breadCrumbs.filter(item => item.nom === 'Accueil');
  const parentLabel = location.state?.label ?? 'Contacts';
  const parentUrl = location.state?.from ?? '/contacts';
  breadcrumbs_temp.push({ url: parentUrl, nom: parentLabel });
  if (contact) {
    breadcrumbs_temp.push({ url: location.pathname, nom: contact });
  }

  const creationRdv = () => {
    setCircular(true);
    const selectedStand = standsChat.find(item => String(item.id) === String(standRdv));
    const standLabel = selectedStand?.description || selectedStand?.code || '';
    creerRdv(
      AccessToken,
      eventId,
      heureDebut,
      heureFin,
      sujetRdv,
      descriptionRdv,
      standRdv,
      idDestRdv,
      standLabel
    )
      .then(reponse => {
        setCircular(false);
        capture('appointment_created_web');

        setEventId('');
        setHeureDebut('');
        setHeureFin('');
        setSujetRdv('');
        setDescriptionRdv('');
        setStandRdv('');
        setIdDestRdv('');

        setOpenRdv(false);
        // window.location.reload()
        navigationPage(0);
      })
      .catch(erreur => {
        setCircular(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }

          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');
              creationRdv();
              // setLoading(false)
              // handleContacts()
            });
          }
        }
      });
  };

  const parseTimeParts = value => {
    const normalized = formatTimeTo24h(value);
    const [rawHour, rawMinute] = normalized.split(':');
    const hour = rawHour && /^\d+$/.test(rawHour) ? rawHour.padStart(2, '0') : '';
    const minute = rawMinute && /^\d+$/.test(rawMinute) ? rawMinute.padStart(2, '0') : '00';
    return { hour, minute };
  };

  const hourOptions = Array.from({ length: 24 }, (_, idx) => String(idx).padStart(2, '0'));
  const minuteOptions = Array.from({ length: 60 }, (_, idx) => String(idx).padStart(2, '0'));

  return (
    <div className="chat-page">
      {/* Modal confirmation suppression discussion */}
      <Modal
        show={openSupprimer}
        style={{ fontFamily: PoliceDefaut }}
        onHide={() => setOpenSupprimer(false)}
      >
        <Modal.Header
          closeVariant="white"
          closeButton
          style={{ color: 'white', backgroundColor: '#134491' }}
        >
          <h4>Confirmation</h4>
        </Modal.Header>
        <form>
          <Modal.Body>
            Voulez-vous vraiment supprimer ce fil de discussion ?
            <div className="d-flex justify-content-end mt-3">
              <Button className="btn-recup" onClick={() => deleteFilDisc(param.chatid)}>
                Confirmer
              </Button>

              <Button
                className="btn-recup2 mx-2"
                variant="secondary"
                onClick={() => setOpenSupprimer(false)}
              >
                Fermer
              </Button>
            </div>
          </Modal.Body>
        </form>
      </Modal>

      {/* Modal créer un rendez-vous */}
      <Modal show={openRdv} style={{ fontFamily: PoliceDefaut }} onHide={() => fermerRdv()}>
        <Modal.Header
          closeVariant="white"
          closeButton
          style={{ color: 'white', backgroundColor: '#134491' }}
        >
          <h4>Mes rendez-vous</h4>
        </Modal.Header>
        <Modal.Body>
          <form>
            {/* disabled={lesRendezvous.destinateur === monProfil.id || lesRendezvous.emeteur === monProfil.id ? true : false} */}
            {lesRendezvous.destinateur === monProfil.id ||
            lesRendezvous.emeteur === monProfil.id ? (
              <div className="py-3">Vous avez déjà un rendez-vous en attente !</div>
            ) : (
              <Form>
                <Row className="mb-2">
                  <Col>
                    <FormSelect value={eventId} onChange={e => choixEvent(e)}>
                      <option value="">Choisir un événement</option>
                      {evenementsChat.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.nom}
                        </option>
                      ))}
                    </FormSelect>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <FormControl
                      className="border"
                      onChange={e => setSujetRdv(e.target.value)}
                      placeholder="Saisir le sujet du rendez-vous"
                    ></FormControl>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <FormControl
                      className="border"
                      onChange={e => setDescriptionRdv(e.target.value)}
                      placeholder="Saisir la description du rendez-vous"
                    ></FormControl>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    Début :{' '}
                    <div className="d-flex align-items-center gap-2">
                      {(() => {
                        const { hour, minute } = parseTimeParts(heureDebut);
                        return (
                          <>
                            <FormSelect
                              className="border"
                              value={hour}
                              onChange={e => {
                                const nextHour = e.target.value;
                                if (nextHour === '') {
                                  setHeureDebut('');
                                  return;
                                }
                                const nextMinute = minute || '00';
                                setHeureDebut(`${nextHour}:${nextMinute}`);
                              }}
                            >
                              <option value="">HH</option>
                              {hourOptions.map(hourValue => (
                                <option key={hourValue} value={hourValue}>
                                  {hourValue}
                                </option>
                              ))}
                            </FormSelect>
                            <span>:</span>
                            <FormSelect
                              className="border"
                              value={minute}
                              onChange={e => {
                                const nextMinute = e.target.value || '00';
                                if (!hour) {
                                  setHeureDebut('');
                                  return;
                                }
                                setHeureDebut(`${hour}:${nextMinute}`);
                              }}
                            >
                              {minuteOptions.map(minuteValue => (
                                <option key={minuteValue} value={minuteValue}>
                                  {minuteValue}
                                </option>
                              ))}
                            </FormSelect>
                          </>
                        );
                      })()}
                    </div>
                  </Col>
                  {/* <Col>Fin : <FormControl type='time' placeholder='Heure de fin' onChange={(e) => { setHeureFin(e.target.value) }}></FormControl></Col> */}
                </Row>
                <Row className="mb-2">
                  <Col>
                    <FormSelect value={standRdv} onChange={e => standLieu(e)} disabled={!eventId}>
                      <option value="">Choisir un stand</option>
                      {standsChat.map((item, index) => (
                        <option
                          key={item.id || index}
                          value={item.id || ''}
                          title={item.description}
                        >
                          {item.description || item.code || 'Stand'}
                        </option>
                      ))}
                    </FormSelect>
                  </Col>
                </Row>

                <div className="d-flex justify-content-end mt-3">
                  <div className="d-flex justify-content-end mt-3">
                    <Col>
                      {circular ? (
                        <CircularProgress />
                      ) : (
                        <Button
                          className="btn-recup"
                          disabled={
                            eventId !== '' &&
                            heureDebut !== '' &&
                            sujetRdv !== '' &&
                            standRdv !== ''
                              ? false
                              : true
                          }
                          onClick={() => creationRdv()}
                        >
                          Valider
                        </Button>
                      )}
                    </Col>

                    <Button
                      className="btn-recup2 mx-3"
                      variant="secondary"
                      onClick={() => fermerRdv()}
                    >
                      Fermer
                    </Button>
                  </div>

                  <Row></Row>
                </div>
              </Form>
            )}
          </form>
        </Modal.Body>
      </Modal>

      <Container fluid className="p-0 flex-shrink-0">
        <Row className="m-0">
          <Navigation
            button={false}
            titre={'Messages'}
            icone={pictos.messagerie_rond_icone}
            photo={monProfil.photo_path}
            retour="dashboard"
            menus={true}
          />
        </Row>

        <Row className="p-0 m-0">
          <Chemin breadCrumbs={breadcrumbs_temp} />
        </Row>
      </Container>

      <ErrorPopup message={msgError} open={openError} close={() => closeErrorHandle()} />

      {showLoading ? (
        <div className="d-flex justify-content-center align-items-center flex-grow-1">
          <ListItemSkeleton count={5} />
        </div>
      ) : (
        <div className="chat-content-wrapper">
          <div className="msgListBox">
            <div className="chat-header-contact border-bottom">
              <Row className="mb-1" style={{ width: '100%', margin: 'auto' }}>
                <Col
                  sm={'auto'}
                  className="d-flex align-items-center"
                  style={{
                    width: 'fit-content',
                    paddingRight: '3px',
                    marginRight: '3px',
                  }}
                >
                  <Avatar src={user_chat.photo !== undefined ? user_chat.photo : ''} />
                </Col>
                <Col className="p-0 mx-2" style={{ width: 'fit-content' }}>
                  <Container className="" fluid style={{}}>
                    <Row className="d">
                      <Col sm="auto" className="p-0 py-1">
                        <Row>
                          <b
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: '1',
                              WebkitBoxOrient: 'vertical',
                            }}
                          >
                            {contact}
                          </b>
                        </Row>
                        <Row className="">
                          <Col className="">{upperFirst(toLower(user_chat.fonction))}</Col>
                        </Row>
                      </Col>
                    </Row>
                  </Container>
                </Col>
                <Col
                  sm="auto"
                  className=" p-1  d-flex justify-content-start align-items-center "
                  style={{ width: 'fit-content' }}
                >
                  <img
                    src={user_chat.from_structure ? null : user_chat.photo_organisation}
                    style={{ width: 'auto', height: '40px' }}
                    alt=""
                  />
                </Col>
                <Col
                  className="p-0 px-1  d-flex justify-content-end align-items-center "
                  style={{ width: '' }}
                >
                  <img
                    className=""
                    onClick={() => ouvrirSupprimer(param.chatid)}
                    src={pictos.poubelle_icone}
                    alt=""
                    style={{ width: '30px', cursor: 'pointer' }}
                  />
                </Col>
              </Row>
            </div>

            <div className="chat-container" id="container-chat">
              <div className="p-3">
                {messageFilDisc.map((message, id) => {
                  let previousDate = id > 0 ? new Date(messageFilDisc[id - 1].createdAt) : null;
                  if (message.user.id === user_id) {
                    let laDate1 = new Date(message.createdAt);

                    return (
                      <ChatSend
                        key={id}
                        message={message}
                        date={affichageDate(laDate1, previousDate)}
                        editable={isMessageEditable(message)}
                        isEditing={editingMessageId === message.id}
                        onStartEdit={() => setEditingMessageId(message.id)}
                        onCancelEdit={() => setEditingMessageId(null)}
                        onSubmitEdit={submitEdit}
                      />
                    );
                  } else {
                    let laDate2 = new Date(message.createdAt);
                    return (
                      <ChatReceive
                        key={id}
                        message={message}
                        date={affichageDate(laDate2, previousDate)}
                      />
                    );
                  }
                })}
              </div>
            </div>

            <Row
              xs={3}
              className="saisie-message d-flex justify-content-center align-items-center py-2 border-top bg-white"
              style={{ height: 'auto', margin: 0 }}
            >
              <IconButton
                className=" col-sm-auto p-0 btn-create-rdv"
                title="Mes rendez-vous"
                variant="plain"
                onClick={() => setOpenRdv(true)}
                sx={{ backgroundColor: 'none', width: 'fit-content' }}
              >
                <img src={pictos.demande_rdv_icone} alt="" width={35} />
              </IconButton>

              <Col
                xs={9}
                sm={10}
                className="d-flex align-items-center areaText"
                style={{ paddingRight: '10px' }}
              >
                <TextareaAutosize
                  id="messageText"
                  className="px-4 pt-2 messageInput d-flex align-items-center"
                  onChange={async e => msgText(e)}
                  onKeyDown={e => {
                    if (e.key === 'Enter' && !e.shiftKey && message !== '') {
                      e.preventDefault();
                      handleClick();
                    }
                  }}
                  placeholder="Message"
                  style={{
                    width: '100%',
                    fontFamily: PoliceDefaut,
                    borderRadius: '25px',
                    border: '1px solid #134491',
                    color: '#134491',
                    resize: 'none',
                  }}
                />
              </Col>

              <Button
                disabled={message !== '' ? false : true}
                className="col btn-send-msg p-0 px-1"
                onClick={handleClick}
                style={{
                  borderRadius: '0',
                  background: 'none',
                  border: 'none',
                  color: '#134491',
                  width: 'fit-content',
                }}
              >
                <Send className="" />
              </Button>
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chatbox;
